import { MenuItem, Select, SelectChangeEvent, Stack } from '@mui/material';
import React, { useState } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import FormAutocomplete from '../../../shared/FormAutocomplete';

interface CutoffInputProps<T> {
    id: string;
    name: string;
    options: T[];
    placeholder: string;
}

const CutoffInput = <T extends { value: any; label: string }>({
    id,
    name,
    options,
    placeholder,
}: CutoffInputProps<T>) => {
    const { control, setValue } = useFormContext();
    const value = useWatch({ control, name });

    const [type, setType] = useState<'default' | 'custom'>(
        value === null ? 'default' : 'custom',
    );

    const handleTypeChange = (event: SelectChangeEvent<string>) => {
        const value = event.target.value as 'default' | 'custom';
        setType(value);

        if (value === 'custom') {
            setValue(name, 0);
        } else {
            setValue(name, null);
        }
    };

    return (
        <Stack direction='row' spacing={0.5}>
            <Select
                size='small'
                value={type}
                onChange={handleTypeChange}
                inputProps={{ size: 'small' }}
            >
                <MenuItem value='default'>Default</MenuItem>
                <MenuItem value='custom'>Custom</MenuItem>
            </Select>
            <FormAutocomplete
                id={id}
                control={control}
                name={name}
                options={options}
                fullWidth
                disabled={type === 'default'}
                placeholder={type === 'default' ? placeholder : ''}
            />
        </Stack>
    );
};

export default CutoffInput;
